module.exports = __webpack_public_path__ + "img/section1.43617257.jpg";